import {createReducer} from '@reduxjs/toolkit'
import {memberLoggedIn as memberLoggedInAction} from '../actions/members'

export const memberLoggedIn = createReducer(false, builder => builder.addCase(memberLoggedInAction, () => true))
